// Core
export { AccessGate } from "./AccessGate";
export type { AccessDecision, AccessBehaviorProps } from "./AccessGate.types";

// Strategies
export { useBenefitStrategy, useRoleStrategy, usePageBuilderAccessStrategies } from "./strategies";

// Behaviors
export {
    HideBehavior,
    DisabledBehavior,
    OverlayBehavior,
    PreviewBehavior,
    RedirectBehavior,
} from "./behaviors";

export type {
    DisabledBehaviorConfig,
    OverlayBehaviorConfig,
    PreviewBehaviorConfig,
    RedirectBehaviorConfig,
} from "./behaviors";
